export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontynuuj"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź hasło potwierdzenia"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło potwierdzenia"])}
}